var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledBoxOpen24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Inventory") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/box-open_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "\\uD83C\\uDF08-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box-open",
    transform: "translate(0.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.650858,5.61622465 C10.2290172,5.61622465 9.83213729,5.39157566 9.6174727,5.03213729 L8.0124805,2.37129485 L6.4099844,5.03213729 C6.19282371,5.39407176 5.79594384,5.61872075 5.37410296,5.61872075 C5.26177847,5.61872075 5.14945398,5.60374415 5.04212168,5.57129485 L1.6224649,4.59282371 L1.6224649,9.03588144 C1.6224649,9.40280811 1.87207488,9.72230889 2.22652106,9.80967239 L7.62308892,11.1600624 C7.87769111,11.2224649 8.14477379,11.2224649 8.39687988,11.1600624 L13.7984399,9.80967239 C14.1528861,9.71981279 14.4024961,9.40031201 14.4024961,9.03588144 L14.4024961,4.59282371 L10.9828393,5.56879875 C10.875507,5.60124805 10.7631825,5.61622465 10.650858,5.61622465 Z M15.9575663,2.81560062 L14.6720749,0.249609984 C14.5946958,0.0948517941 14.4274571,0.00499219969 14.2552262,0.0274570983 L8.0124805,0.823712949 L10.3014041,4.62028081 C10.3962559,4.7775351 10.5859594,4.8524181 10.7631825,4.8024961 L15.7029641,3.39219969 C15.950078,3.31981279 16.0698908,3.04524181 15.9575663,2.81560062 L15.9575663,2.81560062 Z M1.35288612,0.249609984 L0.0673946958,2.81560062 C-0.047425897,3.04524181 0.0748829953,3.31981279 0.31950078,3.38970359 L5.25928237,4.8 C5.43650546,4.849922 5.62620905,4.775039 5.72106084,4.61778471 L8.0124805,0.823712949 L1.76723869,0.0274570983 C1.5950078,0.00748829953 1.43026521,0.0948517941 1.35288612,0.249609984 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledBoxOpen24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_box-open_24px.82d7de6f.svg";
export { ForwardRef as ReactComponent };